/**
 * LAS CANTIDADES CON NOMBRE: «una cucharadita», «al gusto» (Jesús, «El postentreno,
 * cerrado», 27-09: «Los 5 g de cacao son una cucharadita. Que salga así escrito»).
 *
 * Los postentrenos «nuestros» traen algunas cantidades con nombre. Se veían en la lista de
 * sugerencias, pero al pulsar «Usar» se perdían y la comida decía «5 g». Ahora el alimento
 * guarda el nombre y los gramos a los que corresponde; si el cliente cambia la cantidad, el
 * nombre deja de valer y se ve la cantidad normal.
 */
import { num1 } from './numeros';

/** Los campos que viajan con el alimento al pulsar «Usar». */
export const conCantidadConNombre = (a) => ({
    ...(a.texto_cantidad ? { texto_cantidad: a.texto_cantidad, cantidad_con_nombre_g: a.cantidad_g } : {}),
    ...(a.al_gusto ? { al_gusto: true, cantidad_con_nombre_g: a.cantidad_g } : {}),
    ...(a.fijo ? { fijo: true } : {}),
});

/** «una cucharadita (5 g)», «al gusto (200 ml)», o null si no tiene nombre o ya se cambió. */
export const cantidadConNombre = (food) => {
    if (!food || food.cantidad_con_nombre_g == null) return null;
    const qty = food.cantidad_g || 0;
    if (Math.abs(qty - food.cantidad_con_nombre_g) > 0.01) return null;
    const unidad = `${num1(Math.round(qty))} ${food.es_liquido ? 'ml' : 'g'}`;
    if (food.texto_cantidad) return `${food.texto_cantidad} (${unidad})`;
    if (food.al_gusto) return `al gusto (${unidad})`;
    return null;
};
